import * as React from "react";
import "./OpenModalExpenseCommentsButton.scss";
import { useState, useContext, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCommentAlt } from "@fortawesome/free-solid-svg-icons";
import Tooltip from "../../../Tooltip/Tooltip";
import { ServiceContext } from 'src/services/provider/Service.provider';
import { ShowNotification } from 'src/components/common/ShowNotification/ShowNotification';
import { IExpenseComment } from 'src/services/interfaces/Expense/IExpenseComment';
import { IExpenseDetail } from "src/services/interfaces/Expense/IExpenseDetail";
import { ExpenseCommentsTable } from '../../ModalOption/ExpenseCommentsTable';
import { ExpenseCommentModal } from '../../Modal/ExpenseCommentModal';

interface IOpenModalExpenseCommentsButtonProps {
  expense?: IExpenseDetail;
}

export const OpenModalExpenseCommentsButton: React.FC<IOpenModalExpenseCommentsButtonProps> = ({ expense }) => {
  const { expenseCommentService } = useContext(ServiceContext);

  const [loading, setLoading] = useState(false);
  const [showStartView, setShowStartView] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [expenseComments, setExpenseComments] = useState<IExpenseComment[]>([]);

  useEffect(() => {
    fetchComments();
  }, [expense.id]);

  const fetchComments = () => {
    setLoading(true);

    expenseCommentService.getByExpenseId(expense.id)
      .then(setExpenseComments)
      .catch(() => {
        ShowNotification.Error("Falha ao carregar atualizações!", "Ocorreu um erro durante a consulta. Tente novamente.");
      })
      .finally(() => setLoading(false));
  };

  return (
    <>
      <Tooltip text={"Visualizar ou enviar atualizações"}>
        <button className="contact-request btn" onClick={() => setShowModal(true)}>
          <FontAwesomeIcon icon={faCommentAlt} /> Atualizações
        </button>
      </Tooltip>

      <ExpenseCommentModal
        expenseId={expense.id}
        onRefresh={fetchComments}
        loading={loading}
        showStartView={showStartView}
        showModal={showModal}
        onClose={() => setShowModal(false)}
        onViewMessages={() => setShowStartView(true)}
      >
        {showStartView &&
          <ExpenseCommentsTable
            expenseComments={expenseComments}
          />
        }
      </ExpenseCommentModal>
    </>
  );
};


// WEBPACK FOOTER //
// ./src/components/common/ExpenseComments/Buttons/OpenModalExpenseCommentsButton/OpenModalExpenseCommentsButton.tsx